// contexts/JobCompletionContext.js
import React, { createContext, useContext, useState } from "react";

const JobCompletionContext = createContext();

export const useJobCompletion = () => useContext(JobCompletionContext);

export const JobCompletionProvider = ({ children }) => {
  const [completedJobs, setCompletedJobs] = useState(new Set());

  const updateCache = (service) => {
    setCompletedJobs((prev) => new Set([...prev, service]));
  };

  return (
    <JobCompletionContext.Provider value={{ completedJobs, updateCache }}>
      {children}
    </JobCompletionContext.Provider>
  );
};
